export default __webpack_public_path__ + "static/media/bg1Civ.f3a6a8a9.png";